"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _context = require("../context");

var _styled = require("../styled");

var _styled2 = require("./styled");

var _commons = require("../commons");

var _RenderIf = _interopRequireDefault(require("../../RenderIf"));

var Default = _react["default"].forwardRef(function (_props, ref) {
  var _useContext = (0, _react.useContext)(_context.ColorPickerContext),
      colors = _useContext.colors;

  var firstRef = (0, _react.useRef)();
  var lastRef = (0, _react.useRef)();
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        firstRef.current.focus();
      },
      click: function click() {
        firstRef.current.click();
      },
      blur: function blur() {
        lastRef.current.blur();
      }
    };
  });
  var hasColors = colors.length > 0;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_styled2.StyledSaturationContainer, null, _react["default"].createElement(_commons.Saturation, {
    ref: firstRef
  })), _react["default"].createElement(_styled.StyledFlexContainer, null, _react["default"].createElement(_styled2.StyledSlidersContainer, null, _react["default"].createElement(_commons.Hue, null), _react["default"].createElement(_commons.Alpha, null)), _react["default"].createElement(_commons.Preview, null)), _react["default"].createElement(_styled.StyledFlexContainer, null, _react["default"].createElement(_styled2.StyledHexColorContainer, null, _react["default"].createElement(_commons.Hex, null)), _react["default"].createElement(_styled2.StyledRgbaColorContainer, null, _react["default"].createElement(_RenderIf["default"], {
    isTrue: hasColors
  }, _react["default"].createElement(_commons.Rgba, null)), _react["default"].createElement(_RenderIf["default"], {
    isTrue: !hasColors
  }, _react["default"].createElement(_commons.Rgba, {
    ref: lastRef
  })))), _react["default"].createElement(_RenderIf["default"], {
    isTrue: hasColors
  }, _react["default"].createElement(_commons.DefaultColors, {
    ref: lastRef
  })));
});

var _default = Default;
exports["default"] = _default;